import { Button } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const UserDetail = ({row, endPoint}) => {
  const navigate = useNavigate();
    const handleUpdate = ()=>{
        navigate(`/referred-pateint-list/users/${row.patient_code}`)
    }
  return (
    <Button size='small' onClick={()=>handleUpdate(row)} color="primary" sx={{fontSize: "10px", textWrap:"nowrap"}}>Details</Button>
  )
}

export default UserDetail